module.exports = __webpack_public_path__ + "img/btn_start.62e9eeae.png";